import {
  Alert,
  Avatar,
  Col,
  Form,
  Layout,
  Menu,
  Popconfirm,
  Rate,
  Row,
  Spin,
} from "antd";

import React, { ReactElement, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  adminServices,
  getServicePaths,
  isAllowedService,
} from "../../../utils/services";
import { LOGIN_SUCCESS, SIDEBAR_COLLAPSE } from "../../../redux/auth/authType";
import { getImgUrl } from "../../../utils";
import LogoImg from "../../../images/logo.png";
import IconImg from "../../../images/favicon.svg";
import noImage from "../../../images/noImage.png";
import {
  ApartmentOutlined,
  AppstoreOutlined,
  BankOutlined,
  CarryOutOutlined,
  CodepenOutlined,
  ContainerOutlined,
  CopyOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  GiftOutlined,
  IdcardOutlined,
  ProductOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  SolutionOutlined,
  SoundOutlined,
  SyncOutlined,
  TagOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
const { Sider } = Layout;
const { SubMenu } = Menu;
const MainSidebar = (): ReactElement => {
  const { sidebarCollapse, type, shopInfo, merchantInfo } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const pathname = window.location.pathname;
  const [loading, setLoading] = React.useState<boolean>(false);
  const [visiblePopconfirm, setVisiblePopconfirm] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const setCollapsed = (value: boolean) => {
    dispatch({
      type: SIDEBAR_COLLAPSE,
      payload: {
        sidebarCollapse: value,
      },
    });
  };

  const showPopconfirm = (mobileNumber: any) => {
    setVisiblePopconfirm(mobileNumber);
  };

  const handleCancel = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setVisiblePopconfirm(undefined);
  };

  const onSetDefault = async (shopId: any) => {
    if (shopId) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          // userType: res?.usertype || "MERCHANT",
          shopInfo: null,
          //shopId: data?.data?.shop?.id,
          iat: new Date(),
          //type: data?.data?.shop?.type || "JC_COMMERCE",
        },
      });
      navigate("/");
    }
  };

  return (
    <>
      <Sider
        width={300}
        collapsible
        collapsed={sidebarCollapse}
        onCollapse={(value) => {
          setCollapsed(value);
        }}
      >
        <div className="logo sticky top-0 z-10">
          <Link to="/">
            <img
              src={sidebarCollapse ? IconImg : LogoImg}
              alt="jachai parcel"
              className="logoImg"
            />
          </Link>
        </div>

        {!sidebarCollapse &&
          (shopInfo?.id == null || shopInfo?.id == "" ? (
            <div className="bg-transparent text-white shadow-gray-200 border-b mb-4">
              <div className="w-32 h-32 rounded-full bg-gray-100 overflow-hidden mt-5 ml-[25%] relative">
                <img
                  src={
                    merchantInfo?.storeDetails?.profilePicture ||
                    merchantInfo?.merchantPersonalDetail?.profilePicture ||
                    noImage
                  }
                  alt="merchant profile"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>

              <div className="px-4 pb-2">
                <div className=" text-center">
                  <h2 className="text-lg text-white text-center font-bold">
                    {shopInfo?.name ||
                      merchantInfo?.merchantPersonalDetail?.name ||
                      merchantInfo?.storeDetails?.storeName?.toUpperCase() ||
                      merchantInfo?.fullName?.toUpperCase()}
                  </h2>

                  <Rate
                    value={shopInfo?.rating || merchantInfo?.rating || 1}
                    disabled
                  />
                  <span className="bg-blue-100 text-blue-800 text-xs  font-semibold mr-2 px-1 py-0.5 rounded-full dark:bg-blue-200 dark:text-blue-800 ml-2">
                    {shopInfo?.numberOfRating ||
                      merchantInfo?.numberOfRating ||
                      0}
                  </span>
                </div>
                <div className="mb-2 text-sm font-medium bg-gray-300 text-slate-800 rounded-md px-2 py-0.5 mt-2 h-10">
                  <div className="w-9/12 float-left h-full text-start mt-2">
                    {shopInfo?.mobileNumber?.replace("+88", "") ||
                      merchantInfo?.mobileNumber?.replace("+88", "")}
                  </div>
                  <div className="w-3/12 float-left h-full text-right mt-2">
                    {merchantInfo?.isMobileVerified === true ? (
                      <p className="text-green-700 font-bold size-12">
                        Verified
                      </p>
                    ) : (
                      <p className=" text-red-700 font-bold size-12">
                        Unverified
                      </p>
                    )}
                  </div>
                </div>

                <div
                  className="mb-2 text-sm font-medium text-slate-800 rounded-md px-2 py-5 mt-2"
                  style={{ backgroundColor: "#047E94" }}
                >
                  <Row>
                    <Col span={16}>
                      <h2 className="text-lg font-bold text-white">
                        Jachai Membership
                      </h2>
                      <p className="text-white text-xs">
                        Explore offers with a new seller and enjoy more
                        benefits.
                      </p>
                    </Col>
                    <Col span={8}>
                      <div
                        className={
                          "hover:from-pink-500 hover:to-yellow-500 text-white font-bold py-1 mt-6 px-4 rounded-full shadow-md bg-gradient-to-r from-indigo-500 via-pink-500 to-red-500"
                        }
                      >
                        <Link to="/membership-level">Upgrade</Link>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-transparent text-white shadow-gray-200 border-b mb-4">
              <div className="sm:flex__ xl:block sm:space-x-4 xl:space-x-0">
                <div className="w-full overflow-auto h-48">
                  <img
                    src={shopInfo?.banner || noImage}
                    alt=""
                    className="object-cover w-full"
                  />
                </div>
                <div className="px-4 pb-2">
                  <div className="-mt-12 xl:-mt-20">
                    <Avatar
                      size={100}
                      shape="circle"
                      src={getImgUrl(shopInfo?.logo)}
                      className="mb-5 w-20 h-20 shadow-lg border-4 border-white bg-gray-50"
                    />
                  </div>
                  <div>
                    <h2 className="text-xl text-white font-bold -mt-4">
                      {shopInfo?.name?.toUpperCase()}
                    </h2>
                    <ul className="space-y-1">
                      {shopInfo?.balance && (
                        <li className="flex items-center text-sm font-normal text-white">
                          <svg
                            className="mr-2 w-4 h-4 text-white"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                              clipRule="evenodd"
                            ></path>
                            <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"></path>
                          </svg>
                          &#2547;
                          {parseInt(shopInfo?.balance) || 0}
                        </li>
                      )}
                      {shopInfo?.city && (
                        <li className="flex items-center text-sm font-normal text-white">
                          <svg
                            className="mr-2 w-4 h-4 text-white"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                          {shopInfo?.city}
                        </li>
                      )}
                    </ul>

                    {shopInfo?.rating && (
                      <>
                        <Rate
                          value={shopInfo?.rating || 1}
                          className="mt-1"
                          disabled
                        />
                        <span className="bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 ml-3">
                          {shopInfo?.numberOfRating || 0}
                        </span>
                      </>
                    )}
                  </div>{" "}
                  {shopInfo?.mobileNumber && (
                    <div className="mb-4 sm:flex xl:block">
                      <div className="sm:flex-1">
                        <address className="text-sm not-italic font-normal text-gray-500">
                          <div className="mt-4">Mobile Number</div>
                          <div className="mb-2 text-sm font-medium text-white">
                            {shopInfo?.mobileNumber?.split("+88")}
                          </div>
                        </address>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

        <Menu
          defaultOpenKeys={[getServicePaths(pathname)]}
          mode="inline"
          theme="dark"
        >
          {shopInfo?.id == null || shopInfo?.id == "" ? (
            <>
              {adminServices?.map((service, i) => {
                if (service?.sub && service?.sub?.length) {
                  if (
                    service?.sub?.filter((item) => {
                      const excludeIcon = item;
                      return (
                        excludeIcon?.icon &&
                        isAllowedService(`${service.name} ${item.name}`)
                      );
                    })?.length === 1 &&
                    service?.sub?.find((item) => {
                      return item.isParent;
                    })
                  ) {
                    const actualPath = `${service?.path}${service?.sub?.[0]?.path}`;

                    return (
                      <Menu.Item
                        key={service?.path}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                        className={
                          pathname === actualPath && service?.path
                            ? "active"
                            : ""
                        }
                      >
                        <Link to={actualPath}>
                          {type == "JC_FOOD"
                            ? service?.name
                                ?.replace("Shops", "Restaurants")
                                ?.replace("Product", "Menu")
                            : service?.name}
                        </Link>
                      </Menu.Item>
                    );
                  } else {
                    return (
                      service?.sub?.find((item) =>
                        isAllowedService(`${service.name} ${item.name}`)
                      ) && (
                        <SubMenu
                          key={service?.path}
                          icon={<FontAwesomeIcon icon={service?.icon} />}
                          title={service?.name?.replace("Shops", "Restaurants")}
                        >
                          {service?.sub?.map((sub) => {
                            const actualPath = `${service?.path}${sub?.path}`;
                            const excludeIcon = sub;
                            return (
                              !actualPath.includes(":") &&
                              excludeIcon?.icon &&
                              isAllowedService(
                                `${service.name} ${sub.name}`
                              ) && (
                                <Menu.Item
                                  key={actualPath}
                                  icon={<FontAwesomeIcon icon={sub?.icon} />}
                                  className={
                                    pathname === actualPath ? "active" : ""
                                  }
                                >
                                  <Link to={actualPath}>{sub?.name}</Link>
                                </Menu.Item>
                              )
                            );
                          })}
                        </SubMenu>
                      )
                    );
                  }
                } else {
                  return (
                    isAllowedService(`${service.name}`) && (
                      <Menu.Item
                        key={service?.path}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                        className={pathname === service?.path ? "active" : ""}
                      >
                        <Link to={service?.path as any}>{service?.name}</Link>
                      </Menu.Item>
                    )
                  );
                }
              })}
            </>
          ) : (
            <>
              <Menu.Item
                key="/"
                icon={<AppstoreOutlined />}
                className={`hover:text-white hover:bg-gray-100 ${
                  pathname.includes("/") ? "active bg-gray-100" : ""
                }`}
              >
                <Link to={`/`}>Dashboard</Link>
              </Menu.Item>

              <SubMenu
                key={"sub4"}
                icon={<ShoppingCartOutlined />}
                title={"Orders & Review"}
              >
                <Menu.Item
                  key="/orders"
                  icon={<UnorderedListOutlined />}
                  className={`hover:text-white hover:bg-gray-100 ${
                    pathname.includes("/orders") ? "active bg-gray-100" : ""
                  }`}
                >
                  <Link to={`/shops/${shopInfo?.id}/myshop-orders`}>
                    Orders List
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/myshop-return-order"
                  icon={<ShoppingOutlined />}
                  className={`hover:text-white hover:bg-gray-100 ${
                    pathname.includes("/myshop-return-order")
                      ? "active bg-gray-100"
                      : ""
                  }`}
                >
                  <Link to={`/shops/${shopInfo?.id}/myshop-return-order`}>
                    Return Orders
                  </Link>
                </Menu.Item>
                {/* <Menu.Item
                  key="/group-order-list"
                  icon={<ShoppingCartOutlined />}
                  className={`hover:text-white hover:bg-gray-100 ${
                    pathname.includes("/group-order-list")
                      ? "active bg-gray-100"
                      : ""
                  }`}
                >
                  <Link to={`/shops/${shopInfo?.id}/group-order-list`}>
                    Group Buy List
                  </Link>
                </Menu.Item> */}
              </SubMenu>
              {type !== "JC_BOOKING" && type === "JC_AFFILIATE" ? (
                <>
                  <Menu.Item
                    key="/affiliate-products"
                    icon={<ProductOutlined />}
                    className={
                      pathname.includes("/affiliate-products") ? "active" : ""
                    }
                  >
                    <Link to={`/shops/${shopInfo?.id}/affiliate-products`}>
                      Product List
                    </Link>
                  </Menu.Item>
                </>
              ) : (
                <>
                  <SubMenu
                    key={"sub2"}
                    icon={<ProductOutlined />}
                    title={"Product Management"}
                  >
                    <Menu.Item
                      key="/my-shop-products"
                      icon={<FileDoneOutlined />}
                      className={
                        pathname.includes("/my-shop-products")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/my-shop-products`}>
                        My Product
                      </Link>
                    </Menu.Item>
                    {merchantInfo?.type !== "RESELLER" && (
                      <>
                        <Menu.Item
                          key="/myshop-requested-products"
                          icon={<TagOutlined />}
                          className={
                            pathname.includes("/myshop-requested-products")
                              ? "active bg-gray-100"
                              : ""
                          }
                        >
                          <Link
                            to={`/shops/${shopInfo?.id}/myshop-requested-products`}
                          >
                            Requested Products
                          </Link>
                        </Menu.Item>
                      </>
                    )}
                    <Menu.Item
                      key="/myshop-product-catalogue"
                      icon={<CopyOutlined />}
                      className={
                        pathname.includes("/myshop-product-catalogue")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/myshop-product-catalogue`}
                      >
                        Product Catalogue
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/myshop-out-of-stock"
                      icon={<FileSearchOutlined />}
                      className={
                        pathname.includes("/myshop-out-of-stock")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/myshop-out-of-stock`}>
                        Out of Stock
                      </Link>
                    </Menu.Item>
                    {/* <Menu.Item
                      key="/brands"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/brands") ? "active bg-gray-100" : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/brands`}>
                        Brand List
                      </Link>
                    </Menu.Item> */}
                  </SubMenu>
                  <SubMenu
                    key={"sub20"}
                    icon={<ProductOutlined />}
                    title={"Settlement"}
                  >
                    <Menu.Item
                      key={`/my-shop/${shopInfo?.id}/unsettled-orders`}
                      icon={<FileDoneOutlined />}
                      className={
                        pathname.includes(`/my-shop/${shopInfo?.id}/unsettled-orders`)
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/my-shop/${shopInfo?.id}/unsettled-orders`}>
                      Unsettled Orders
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key={`/my-shop/${shopInfo?.id}/settled-orders`}
                      icon={<FileDoneOutlined />}
                      className={
                        pathname.includes(`/my-shop/${shopInfo?.id}/settled-orders`)
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/my-shop/${shopInfo?.id}/settled-orders`}>
                      Settled Orders
                      </Link>
                    </Menu.Item>
                   
                  
                  </SubMenu>
                  <Menu.Item
                    key="/myshop-categories"
                    icon={<ApartmentOutlined />}
                    className={`hover:text-white hover:bg-gray-100 ${
                      pathname.includes("/myshop-categories") ? "active bg-gray-100" : ""
                    }`}
                  >
                    <Link to={`/shops/${shopInfo?.id}/myshop-categories`}>Customize Category</Link>
                  </Menu.Item>
                  <SubMenu
                    key={"sub3"}
                    icon={<GiftOutlined />}
                    title={"My Promotion"}
                  >
                    <Menu.Item
                      key="/myshop-campaign"
                      icon={<SoundOutlined />}
                      className={
                        pathname.includes("/myshop-campaign")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/myshop-campaign`}>
                        Campaign
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key="/myshop-promo-code"
                      icon={<CodepenOutlined />}
                      className={
                        pathname.includes("/myshop-promo-code")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/myshop-promo-code`}>
                        Promo Code
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  {/* <SubMenu
                    key={"sub6"}
                    icon={<AppstoreOutlined />}
                    title={"Reports"}
                  >
                    <Menu.Item
                      key="/sales-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/sales-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/sales-report`}>
                        Sales Report
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/sales-summary"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/sales-summary")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/sales-summary`}>
                        Sales Summary
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/top-sales-product"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/top-sales-product")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/top-sales-product`}>
                        Top Sales Product
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/top-sales-product-details"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/top-sales-product-details")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/top-sales-product-details`}
                      >
                        Top Sales Product Details
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/sales-category-wise-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/sales-category-wise-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/sales-category-wise-report`}
                      >
                        Sales Category Wise Report
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/return-sales-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/return-sales-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/return-sales-report`}>
                        Return Sales Report
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/return-sales-summary-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/return-sales-summary-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/return-sales-summary-report`}
                      >
                        Return Sales Summary
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/return-top-sales-product-details-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes(
                          "/return-top-sales-product-details-report"
                        )
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/return-top-sales-product-details-report`}
                      >
                        Return Sales Product Details
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/stock-out-product-summary-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/stock-out-product-summary-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/stock-out-product-summary-report`}
                      >
                        Stock Out Product Summary
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/stock-out-product-summary-report-with-date-wise"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes(
                          "/stock-out-product-summary-report-with-date-wise"
                        )
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/stock-out-product-summary-report-with-date-wise`}
                      >
                        Stock Out Product Summary With Date
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/return-top-sales-product-summary-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes(
                          "/return-top-sales-product-summary-report"
                        )
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/return-top-sales-product-summary-report`}
                      >
                        Return Top Sales Product Summary
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/return-sales-category-wise-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/return-sales-category-wise-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/return-sales-category-wise-report`}
                      >
                        Return Sales Category Wise
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/promo-wise-sales-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/promo-wise-sales-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/promo-wise-sales-report`}
                      >
                        Promo Wise Sales Report
                      </Link>
                    </Menu.Item>
                  </SubMenu> */}
                  <SubMenu
                    key={"sub1"}
                    icon={<IdcardOutlined />}
                    title={"Basic Information"}
                  >
                    <Menu.Item
                      key="/myshop-details"
                      className={`hover:text-white hover:bg-gray-100 ${
                        pathname.includes("/myshop-details")
                          ? "active bg-gray-100"
                          : ""
                      }`}
                      icon={<IdcardOutlined />}
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/myshop-details`}
                        className="hover:text-white"
                      >
                        General Info
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/shop-business-contract-info"
                      className={`hover:text-white hover:bg-gray-100 ${
                        pathname.includes("/shop-business-contract-info")
                          ? "active bg-gray-100"
                          : ""
                      }`}
                      icon={<ContainerOutlined />}
                    >
                      <Link
                        to={`/shops/${shopInfo?.id}/shop-business-contract-info`}
                        className="hover:text-white"
                      >
                        Business & Contract Info
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/shop-business-info"
                      icon={<CarryOutOutlined />}
                      className={
                        pathname.includes("/shop-business-info")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/shop-business-info`}>
                        Business Info
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/shop-banks"
                      icon={<BankOutlined />}
                      className={
                        pathname.includes("/shop-banks")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/shop-banks`}>
                        Bank Info
                      </Link>
                    </Menu.Item>
                    {/* <Menu.Item
                  key="/users"
                  icon={<SolutionOutlined />}
                  className={
                    pathname.includes("/users") ? "active bg-gray-100" : ""
                  }
                >
                  <Link to={`/shops/${shopInfo?.id}/users`}>Users</Link>
                </Menu.Item> */}

                    {/* <Menu.Item
                  key="/facebook-page"
                  icon={<SolutionOutlined />}
                  className={
                    pathname.includes("/facebook-page")
                      ? "active bg-gray-100"
                      : ""
                  }
                >
                  <Link to={`/shops/${shopInfo?.id}/facebook-page`}>
                    Facebook Page & Group
                  </Link>
                </Menu.Item> */}
                  </SubMenu>
                  {/* <Menu.Item
                    key="/chats"
                    icon={<SolutionOutlined />}
                    className={
                      pathname.includes("/chats") ? "active bg-gray-100" : ""
                    }
                  >
                    <Link to={`/shops/${shopInfo?.id}/chats`}>Chats</Link>
                  </Menu.Item> */}
                </>
              )}

              <Menu.Item
                key="/transactions"
                icon={<SyncOutlined />}
                className={pathname.includes("/transactions") ? "active" : ""}
              >
                <Popconfirm
                  placement="left"
                  title="Do you want to login this Merchant?"
                  visible={shopInfo?.id === visiblePopconfirm}
                  onConfirm={(e: any) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onSetDefault(shopInfo?.id);
                  }}
                  okButtonProps={{
                    loading: confirmLoading,
                    className: "bg-blue-400",
                    shape: "round",
                  }}
                  cancelButtonProps={{
                    danger: true,
                    type: "primary",
                    shape: "round",
                  }}
                  okText="Yes"
                  cancelText="Not now"
                  onCancel={handleCancel}
                >
                  <Link
                    to={""}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      showPopconfirm(shopInfo?.id);
                    }}
                  >
                    Switch to Merchant
                  </Link>
                </Popconfirm>
              </Menu.Item>
            </>
          )}
        </Menu>
      </Sider>
    </>
  );
};

export default MainSidebar;
